import { useSearchParams } from 'react-router-dom';
import { AssetView as LegacyAssetView } from '../views/AssetView';
import { AssetView } from './AssetView';

export const VIEW_PARAM = 'view';
export const LEGACY_VIEW_VALUE = 'legacy';

export function AssetRoute() {
    const [searchParams] = useSearchParams();
    return searchParams.get(VIEW_PARAM) === LEGACY_VIEW_VALUE ? (
        <LegacyAssetView />
    ) : (
        <AssetView />
    );
}
